import { initialize } from '@/common/services/eventBusService'

export default () => {
  initialize()
}
